import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import estilos from '../PanelDetalleCliente/PanelDictamenesComponent.module.css';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Typography, TextField, MenuItem, Button, Autocomplete } from '@mui/material';
import moment from 'moment'
import BotonVerDictamenesComponent from './BotonVerDictamenesComponent';
import {
    AgregarDictamenFiscal, obtenerDictamenFiscal, ActualizarDictamenFiscal,
    obtenerDictamenesFiscalesByYear, obtenerFolioDictamen, actualizarFolioOficioDictamen
} from '../../../../redux/DucksAtencionACliente/UsuariosAtencionAClienteDuck';
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../../redux/AppDucks';

function DictamenFiscalComponent(props) {
    const fechaHoy = moment().format('YYYY-MM-DD')
    const dispatch = useDispatch();

    const solicitud = useSelector(store => store.UsuariosAtencionACliente.informacionClienteDictamen)

    const [fechasolicitud, setFechaSolicitud] = React.useState(fechaHoy)
    const [fechaoperaciones, setFechaOperaciones] = React.useState('')
    const [fechacambio, setFechaCambio] = React.useState('')
    const [regimenfiscal, setRegimenFiscal] = React.useState('')
    const [actividadeseconomicas, setActividadesEconomicas] = React.useState('')
    const [fechaemision, setFechaEmision] = React.useState('')
    const [estatuspadron, setEstatusPadron] = React.useState('Activo')
    const [documentoempara, setDocumentoEmpara] = React.useState('CONSTANCIA DE SITUACIÓN FISCAL.')
    const [conclusion, setConclusion] = React.useState('Con base a la información presentada por el cliente, se concluye que cumple con los requisitos requeridos.')

    const [isDictamen, setIsDictamen] = React.useState(false)
    const [resultado, setResultado] = React.useState([])

    const [openModal, setOpenModal] = React.useState(false)
    const [titleModal, setTitleModal] = React.useState('')
    const [bodyModal, setBodyModal] = React.useState('')
    const closeModal = () => setOpenModal(false)

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        border: 'none',
        boxShadow: 24,
        p: 4,
    };


    const estatusrfc = [
        { value: 'Activo', label: 'Activo', },
        { value: 'Inactivo', label: 'Inactivo', },
        { value: 'Reactivado', label: 'Reactivado', },
    ];

    const regimenFiscalArray = [
        { title: 'Régimen General de Ley Personas Morales.' },
        { title: 'Régimen Simplificado de Confianza.' },
        { title: 'Régimen de las Personas Físicas con Actividades Empresariales y Profesionales.' },
        { title: 'Régimen de Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras.' },
        { title: 'Régimen de Incorporación Fiscal.' },
        { title: 'Régimen de Sueldos y Salarios e Ingresos Asimilados a Salarios.' },
        { title: 'Régimen de Ingresos por Dividendos (socios y accionistas).' }
    ];

    const actividadesSATArray = [
        { title: 'Siembra, cultivo y cosecha de agave o maguey tequilero.' },
        { title: 'Producción, fabricación, o envasado de bebidas destiladas de agave.' },
        { title: 'Producción, fabricación, o envasado de bebidas destiladas de agave con una graduación alcohólica de más de 20º G.L.' },
        { title: 'Comercio al por menor de bebidas destiladas de agave.' },
        { title: 'Comercio al por mayor de bebidas destiladas de agave.' }
    ];

    React.useEffect(async () => {
        let result = await dispatch(obtenerDictamenFiscal(solicitud?.idcliente))

        if (result?.payload?.length > 0) {
            setRegimenFiscal(result?.payload?.[0]?.regimenfiscal)
            setActividadesEconomicas(result?.payload?.[0]?.actividadeseconomicas)
            setEstatusPadron(result?.payload?.[0]?.estatuspadron)
            setDocumentoEmpara(result?.payload?.[0]?.documentoempara)
            setConclusion(result?.payload?.[0]?.conclusion)
            setFechaSolicitud(moment(result?.payload?.[0]?.fechasolicitud).add(1, 'd').format('YYYY-MM-DD'))
            setFechaOperaciones(moment(result?.payload?.[0]?.fechaoperaciones).add(1, 'd').format('YYYY-MM-DD'))
            setFechaCambio(moment(result?.payload?.[0]?.fechacambio).add(1, 'd').format('YYYY-MM-DD'))
            setFechaEmision(moment(result?.payload?.[0]?.fechaemision).add(1, 'd').format('YYYY-MM-DD'))
            setIsDictamen(true)
            setResultado(result?.payload?.[0])
        }
    }, [])

    const GenerarDictamenFiscal = async () => {
        if(fechaoperaciones == '' || fechacambio == '' || regimenfiscal == '' || actividadeseconomicas == '' || fechaemision == '' || estatuspadron== ''){
            setTitleModal("¡Alerta!")
            setBodyModal("Debe de rellenar todos los campos para poder generar el Dictamen Fiscal.")
            setOpenModal(true)
        } else {        
            await dispatch(actualizarLoadingApp_true())
            var año = moment().format('YYYY');
            let year = String(año)
            let contadorFolio = await dispatch(obtenerDictamenesFiscalesByYear(year))
            let folio = '0001'
            if (contadorFolio?.payload > 0) {
                let obtenerFolio = await dispatch(obtenerFolioDictamen(1))
                const nuevoFolio = ('000' + (parseInt(obtenerFolio?.payload?.folio, 10) + 1)).slice(-4)
                folio = nuevoFolio
            }
            let datesolicitud = new Date(fechasolicitud).toISOString()
            let dateoperaciones = new Date(fechaoperaciones).toISOString()
            let datecambio = new Date(fechacambio).toISOString()
            let daeemision = new Date(fechaemision).toISOString()
            let cadenaProductiva = ''
            for (const i in solicitud?.actividadcliente) {
                if (cadenaProductiva === '') cadenaProductiva += solicitud?.actividadcliente?.[i]?.tipoactividad?.actividad
                else cadenaProductiva += ',' + solicitud?.actividadcliente?.[i]?.tipoactividad?.actividad
            }
            let arregloCadena = cadenaProductiva.split(',')
            let combinacionCadena = ''
            let contador = 1
            for (const i in arregloCadena) {
                if (arregloCadena.length === 1) {
                    combinacionCadena += arregloCadena[i]
                } else {
                    if (arregloCadena.length === (contador + 1)) {
                        combinacionCadena += arregloCadena[i] + ' y '
                        contador++
                    } else {
                        combinacionCadena += arregloCadena[i]
                        if (arregloCadena.length !== contador) {
                            combinacionCadena += ', '
                        }
                        contador++
                    }
                }
            }
            await dispatch(actualizarLoadingApp_false())
            if (!isDictamen) {
                await dispatch(actualizarLoadingApp_true())
                let dataFiscal = {
                    fechasolicitud: datesolicitud, numeroinforme: 'DF-' + folio + '/' + year, nombrerazonsocial: solicitud?.nombrerazonsocial,
                    actividadcrm: combinacionCadena, fechaoperaciones: dateoperaciones, fechacambio: datecambio,
                    regimenfiscal: regimenfiscal, actividadeseconomicas: actividadeseconomicas,
                    documentoempara: documentoempara, fechaemision: daeemision, rfc: solicitud?.rfc,
                    estatuspadron: estatuspadron, conclusion: conclusion,
                    idcliente: solicitud.idcliente
                }
                let resultado = await dispatch(AgregarDictamenFiscal(dataFiscal))
                setIsDictamen(true)
                setResultado(resultado?.payload)
                await dispatch(actualizarLoadingApp_false())
                setTitleModal("Nuevo dictamen.")
                setBodyModal("El Dictamen Fiscal se generó correctamente.")
                setOpenModal(true)
            } else {
                await dispatch(actualizarLoadingApp_true())
                let dataFiscal = {
                    fechasolicitud: datesolicitud, numeroinforme: 'DF-' + folio + '/' + year, nombrerazonsocial: solicitud?.nombrerazonsocial,
                    actividadcrm: combinacionCadena, fechaoperaciones: dateoperaciones, fechacambio: datecambio,
                    regimenfiscal: regimenfiscal, actividadeseconomicas: actividadeseconomicas,
                    documentoempara: documentoempara, fechaemision: daeemision, rfc: solicitud?.rfc,
                    estatuspadron: estatuspadron, conclusion: conclusion,
                    idcliente: solicitud.idcliente, iddictamenfiscalcliente: resultado?.iddictamenfiscalcliente
                }
                await dispatch(ActualizarDictamenFiscal(dataFiscal))
                await dispatch(actualizarLoadingApp_false())
                setTitleModal("Actualización.")
                setBodyModal("El Dictamen Fiscal se actualizó correctamente.")
                setOpenModal(true)
            }

            await dispatch(actualizarFolioOficioDictamen({ idfoliodictamen: 1, folio: folio }))
        }
    }

    return (
        <div className='container'>
            <div style={{ textAlign: 'start' }}>
                <BotonVerDictamenesComponent tabla={'documentodictamenfiscal'} nombreId={'idcliente'} idSolicitud={solicitud.idcliente} disabled={resultado?.iddictamenfiscalcliente != null && resultado?.iddictamenfiscalcliente != undefined ? true : false} />
            </div>

            <div className={`mb-3 ${estilos.divSoloBorderNaranja} row mt-3`}>
                <h3>DICTAMEN FISCAL</h3>
                <div className="col-md-4">
                    <TextField id="outlined-basic" label="Fecha de solicitud" variant="outlined" style={{ width: '100%' }} type='date'
                        //InputProps={{ inputProps: { max: fechaHoy } }}
                        InputLabelProps={{ shrink: true, }} value={fechasolicitud} onChange={e => setFechaSolicitud(e.target.value)} />
                </div>

                <div className="col-md-12 mt-3">
                    <Autocomplete id="free-solo-demo" freeSolo
                        value={regimenfiscal}
                        onInputChange={(e, value) => { setRegimenFiscal(value); }}
                        options={regimenFiscalArray.map((option) => option.title)}
                        style={{ width: '100%' }}
                        renderInput={(params) => <TextField {...params} label="Régimen fiscal" InputLabelProps={{ shrink: true }} />} />
                </div>

                <div className="col-md-8 mt-3">
                    <Autocomplete id="free-solo-demo" freeSolo
                        value={actividadeseconomicas}
                        onInputChange={(e, value) => { setActividadesEconomicas(value); }}
                        options={actividadesSATArray.map((option) => option.title)}
                        style={{ width: '100%' }}
                        renderInput={(params) => <TextField {...params} label="Actividades económicas registradas en el SAT" InputLabelProps={{ shrink: true }} />} />
                </div>

                <div className="col-md-4 mt-3">
                    <TextField id="outlined-select-currency" select label="Estatus del padrón del RFC" defaultValue="" style={{ width: '100%' }}
                        value={estatuspadron} onChange={e => setEstatusPadron(e.target.value)} >
                        {estatusrfc.map((option) => (
                            <MenuItem key={option.value} value={option.value}> {option.label} </MenuItem>
                        ))}
                    </TextField>
                </div>

                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Fecha inicio de operaciones" variant="outlined" style={{ width: '100%' }} type='date'
                        InputLabelProps={{ shrink: true, }} value={fechaoperaciones} onChange={e => setFechaOperaciones(e.target.value)} />
                </div>

                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Fecha de último cambio" variant="outlined" style={{ width: '100%' }} type='date'
                        InputLabelProps={{ shrink: true, }} value={fechacambio} onChange={e => setFechaCambio(e.target.value)} />
                </div>

                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Fecha de emisión de la CSF" variant="outlined" style={{ width: '100%' }} type='date'
                        InputLabelProps={{ shrink: true, }} value={fechaemision} onChange={e => setFechaEmision(e.target.value)} />
                </div>

                <div className="col-md-12 mt-3">
                    <TextField id="outlined-multiline-flexible" label="Conclusión" multiline maxRows={4} style={{ width: '100%' }}
                        value={conclusion} onChange={e => setConclusion(e.target.value)} />
                </div>

                <div className="col-md-12 mt-3">
                    <Button variant="contained" color="success" onClick={() => GenerarDictamenFiscal()}>  Generar Dictamen Fiscal </Button>
                </div>
            </div>

            <Modal
                open={openModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" style={{ textAlign: 'center' }}>
                        <strong>{titleModal}</strong>
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 3 }} style={{ textAlign: 'center' }}>
                        {bodyModal}
                    </Typography>
                    <Typography sx={{ mt: 5 }} className='text-center'>
                        <button className='btn btn-success' onClick={closeModal} style={{ width: '60%' }} > Aceptar </button>
                    </Typography>
                </Box>
            </Modal>
        </div>
    )
}
export default withRouter(DictamenFiscalComponent)
